import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/store";
import { useGetUserQuery } from "../../services/auth";
import { setCredentials } from "../../reducers/authSlice";
import { getFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import { User } from "../../types/User";

const ManageProfile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [user, setUser] = useState<any>(null);
  
  // Get user data from API
  const { data: userData, isLoading, refetch } = useGetUserQuery({});

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await refetch();
        if (result?.data?.statusCode === 200 && token) {
          dispatch(
            setCredentials({
              token: `${token}`,
              user: result?.data?.data,
            })
          );
          setUser(result?.data?.data);
        }
      } catch (error: any) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (userData?.data) {
      setUser(userData.data);
    }
  }, [userData]);

  useEffect(() => {
    getUserDetails();
  }, []);

  // Default values for loading state
  const userName = user?.first_name || user?.name || "Loading...";
  const userEmail = user?.email || "Loading...";
  const userPhone = "+971 1234567890"; // Static phone number
  const userImage = user?.profile_picture?.media_file_url || user?.image || "/static/images/admin_icon.png";

  return (
    <>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Profile
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>General Details</h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-profile/edit")}><EditIcon /> Edit Profile</Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={userImage} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{userName}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{userEmail}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{userPhone}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProfile;
